const pathname = window.location.pathname
const search = window.location.search
const pathSpotId = pathname.split('/').pop();

export default () => {
  let isSpot = true;
  let isFavoriteSpot = false;
  let isArbitrarySpot = false;
  let id;
  let lat;
  let lon;

  // use for dev
  if (pathname.indexOf('/complete-report') > -1) {
    id = 93337
    // id = 180917
    // id = 168372
    // lat = '41.151'
    // lon = '-123.932'
    // isArbitrarySpot = true
    // isFavoriteSpot = true
    // isSpot = false
  }

  if (pathname.indexOf('/spot/') > -1) {
    id = pathSpotId;
  }

  if (pathname.indexOf('/favspot/') > -1) {
    const match = pathname.match(/\/favspot\/(\d+)/)
    id = match ? match[1] : null
    isFavoriteSpot = true;
    isSpot = false;
  }

  if (search.indexOf('latlon') > -1) {
    const params = new URL(document.location).searchParams
    const coords = params.get('latlon').split(',');

    lat = coords[0];
    lon = coords[1];
    isArbitrarySpot = true;
    isSpot = false;
  }

  return {
    id,
    lat,
    lon,
    isSpot,
    isFavoriteSpot,
    isArbitrarySpot
  }
}